module.exports = __webpack_public_path__ + "img/fox.a7e8d5e4.jpg";